module.exports = __webpack_public_path__ + "static/access_handbook_new_395x386-f38a7d86418572682905c3996301e672.png";